"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_GlassCannon_OnDamagedEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
let Effect_GlassCannon_OnDamagedEventHandlerScript = class Effect_GlassCannon_OnDamagedEventHandlerScript {
    run(sequence, container, handler, event) {
        if (container.isDeceased(event.subject)) {
            return;
        }
        // 25% chance
        const roll = (0, Random_1.random)(1, 4);
        if (roll === 2) {
            container.applyFloatingText(sequence, event.subject, "clink", "white", "small");
        }
        if (roll !== 1) {
            return;
        }
        sequence = sequence.pushSequence("parallel");
        container.applyDebuff({
            sequence,
            attackerId: event.subject,
            targetId: event.args.damagedBy,
            duration: Duration_1.Duration.Turns(2),
            effect: new core_1.BadLuckEffectArgs(),
        });
        container.applyEffect(sequence, event.args.damagedBy, event.subject, new core_1.DeathEffectArgs(), Duration_1.Duration.Permanent, true);
    }
};
Effect_GlassCannon_OnDamagedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_GlassCannon_OnDamaged")
], Effect_GlassCannon_OnDamagedEventHandlerScript);
exports.Effect_GlassCannon_OnDamagedEventHandlerScript = Effect_GlassCannon_OnDamagedEventHandlerScript;
